import React from "react";
import {Button, Columns, Heading, Modal, Section} from "react-bulma-components";
import TrackingOptionsPicker from "../Settings/TrackingCategory/TrackingOptionsPicker";


export function TrackingOptionModal({open, setOpen, onComplete, trackingOptions, onTrackingOptionChange, partOrder}) {
    // Add tracking option to data sent to complete view
    const onCompleteClick = () => {
        //check if correct field has been entered
    }

    return (
        <Modal
            closeOnBlur
            onClose={() => {
                setOpen(false)
            }}
            show={open}
        >
            <Modal.Content>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column>
                            <Heading>Add Tracking Category to Invoice</Heading>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <TrackingOptionsPicker
                                name={"tracking_option"}
                                onChange={onTrackingOptionChange}
                                value={partOrder.tracking_option}
                                label={"Tracking Option"}
                                inlineEdit={false}
                                editable={true}
                                options={trackingOptions}
                                blank={true}
                            />
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Button
                                color={"success"}
                                onClick={() => {
                                    onComplete();
                                    setOpen(false);
                                }}
                                fullwidth
                            >
                                Complete
                            </Button>
                        </Columns.Column>
                        <Columns.Column>
                            <Button
                                color={"info"}
                                onClick={() => {
                                    setOpen(false);
                                }}
                                fullwidth
                            >
                                Cancel
                            </Button>
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )


}